angular.module("ainapp")
    .controller("docNumberController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Document Number";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {


            }
            $scope.Init();

            $scope.documentSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.TraceInKendo(o.data).then(function (response) {
                            o.success(response.data)
                        })
                    },
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {

                            Type: {
                                type: "string",
                                editable: false,

                            },
                            Prefix: {
                                type: "string",
                                editable: true,
                            },
                            Number: {
                                type: "double",
                                editable: true,
                            },
                            "Branch.Name": {
                                type: "string",
                                editable: true,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,

            });
            $scope.DocumentDetailsGridOptions = {
                editable: true,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.documentSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "Type",
                        title: "Type",
                    },
                    {
                        field: "Prefix",
                        title: "Prefix",
                    },
                    {
                        field: "Number",
                        title: "Number",
                    },
                    {
                        field: "Branch.Name",
                        title: "Branch Name",
                    },
                    {
                        title: "Options",
                        template: "<button class=' btn-default btn-sm fa fa-save' ng-click='Save(dataItem)'> </button> ",
                        width: '50px'
                    },
                ],



            };



            $scope.Save = function (trace) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdatetraceNumber(trace).then(function (response) {
                    if (response.data) {
                        $("#DocumentDetails-master-grid").data("kendoGrid").dataSource.read();
                        toastr.success("Success");
                        $scope.Init();
                    } else {
                        toastr.error("Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });

            }



        }])
